import { Button, ButtonColorStyle, ButtonSize } from '@wix/vmaf-adi-components';
import React from 'react';
import CenteredLayout, { PageHeader } from '../layouts/CenteredLayout';
import styles from './ErrorOverlayBase.scss';

interface IErrorOverlayBaseProps {
  title: string;
  subtitle: string;
  actionLabel: string;
  onAction(e: React.MouseEvent<HTMLButtonElement>): void;
}

const ErrorOverlayBase: React.FC<IErrorOverlayBaseProps> = ({
  title,
  subtitle,
  actionLabel,
  onAction,
}) => {
  return (
    <CenteredLayout>
      <PageHeader />
      <div className={styles.centered}>
        <div className={styles.illustration} />
        <div className={styles.texts}>
          <div className={styles.title}>{title}</div>
          <div className={styles.subtitle}>{subtitle}</div>
        </div>
        <div className={styles.action}>
          <Button
            onClick={onAction}
            colorStyle={ButtonColorStyle.OUTLINE}
            size={ButtonSize.LARGE}
          >
            {actionLabel}
          </Button>
        </div>
      </div>
    </CenteredLayout>
  );
};

export default ErrorOverlayBase;
